module.exports = __webpack_public_path__ + "static/logo_w-71d8ef8c19049ef81c0a78be4b834986.svg";